<script>

  import {ignore} from '../../../Common/tools';
  import {M} from '../../../external';
  import {getAttachmentName, validateVoiceMessage} from '../../../CRM/Popups/messages/common';
  import VoiceEditor from "../../../CRM/Popups/messages/VoiceEditor.svelte";

  export let data = {}, onChange = ignore, valid, error;
  let message;

  if (!data.settings) {
    data.settings = [];
  }

  if(data.settings[0]) {
    message = JSON.parse(data.settings[0].value);
  }

  function updateSettings(message) {
    try {
      valid = validateVoiceMessage(message);
    } catch (e) {
      error = e;
      valid = false;

      if (!message.body.length && !message.attachments) {
        return;
      }
    }

    if (valid) {
      data.settings[0] = {
        key: '0',
        value: JSON.stringify(message)
      };

      let name = message.body ? message.body : getAttachmentName(message.attachments[0]); //either the message or audio is valid
      if (name.length > 30) {
        name = name.substring(0, 30) + "...";
      }
      data.name = '"' + name + '"';
    }

    onChange();
  }

</script>

<div class='col20 f-left small-rules mb-25'>
  <h4 class='col20 f-left mt-5 mb-25 mb-15 t-center' style='line-height:1.4;'>{M.SEND_VOICE}</h4>

  <div class='col20 f-left mt-20'>
    <VoiceEditor {message} onChange={updateSettings} />
  </div>
</div>
